import type { PlanType } from '@painpal/contracts';
import { colors, PLAN_COLORS } from '../../theme/tokens';
import { PLAN_LABELS } from './planModel';
import styles from './planTag.module.css';

export interface PlanTagProps { type: PlanType; missed?: boolean; size?: 'row' | 'strip' }

// A missed day's tag is quiet: paper fill, grey stroke and text, struck through, never hot.
export function PlanTag({ type, missed = false, size = 'row' }: PlanTagProps) {
  return (
    <span className={styles.tag} data-type={type} data-missed={missed || undefined} data-size={size} style={{ background: missed ? colors.paper : PLAN_COLORS[type] }}>
      {PLAN_LABELS[type]}
    </span>
  );
}
